export const CLASSTING_LEGACY_AUTH_URL = process.env.REACT_APP_AUTH_URL;

export const CLASSTING_AUTH_URL = process.env.REACT_APP_OIDC_URL;
export const CLASSTING_CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID;
export const ACCOUNT_SERVICE_URL = process.env.REACT_APP_ACCOUNT_SERVICE_URL;
